/*
#HandlePageOnClick ==> for redirect pages 
#BreadcrumbsItem  ==> for dynamic breadcrumb
#imported material-ui components
#imported react-share components
#serviceProvider ==> for api call
*/

import React, { Component, useState, useEffect, useRef } from "react";
import { HandlePageOnClick } from "../../webutils/webutils";
import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import { Link } from "react-router-dom";
import serviceProvider from '../../services/axios'
import Plyr from "plyr";
import "plyr/dist/plyr.css";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { Helmet } from "react-helmet";
import { apiEndpoints } from '../../services/api-endpoints';
// training progressbar
const TrainProgressBar = (props) => {
	return (
		<>
			<div className="t__progressbar__wrapper">
				<div className="t__progressbar__left">
					<p>Progress:</p>
				</div>
				<div className="t__progressbar__right">
					<div className="t__progress__relative">
						<div
							className={
								props.value < 100 && props.value > 0
									? "t__progress__status__wrapper progress"
									: props.value === 100
									? "t__progress__status__wrapper completed"
									: "t__progress__status__wrapper not__start"
							}
						>
							<div className="t__progress__status" style={{ width: `${props.value}%` }}></div>
						</div>
						<div className="t__progress__txt">{props.value}%</div>
					</div>
				</div>
				<div className="t__progressbar__space"></div>
				<div className="t__progressbar__left">
					<p>
						Done:<span className="b">{props.doneTime}</span>
					</p>
				</div>
				<div className="t__progressbar__right">
					<p>
						Left:<span className="b">{props.leftTime}</span>
					</p>
				</div>
			</div>
		</>
	);
};

// content list component
const ContentList = (props) => {
	return (
	<Link to={`/training-courses/${props.course_slug}/${props.section_slug}`}>	

		<li className="course__inner__li" onClick={props.callBackFunction}>
			<div className="course__inner__li__icon">
				<div className="course__inner__li__icon">
					{props.status === "play" ? (
						<img src={require("../../assets/img/course-overview/vid_play.svg").default} className="vid__play" alt="vid_play_img" />
					) : props.status === "complete" ? (
						<img
							src={require("../../assets/img/course-overview/vid_completed.svg").default}
							className="vid-completed"
							alt="vid_completed_img"
						/>
					) : (
						<img src={require("../../assets/img/course-overview/vid_lock.svg").default} className="vid_lock" alt="vid_lock_img" />
					)}
				</div>
			</div>
			<div className="course__inner__li__txt">
				<p className="h1__title">{props.listTitle}</p>
				<p className="time__text">{props.listTime}</p>
			</div>
		</li>
		</Link>
	);
};

// SvgCircle component
const SvgCircle = (props) => {
	const { value } = props;
	return (
		<svg viewBox="0 0 36 36">
			<text className="percent__text" x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fontSize="10">
				{value}
				<tspan fontSize="5">%</tspan>
			</text>
			<path
				className="circle-bg"
				d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
				stroke="#EBF5FA"
				strokeWidth="2.4"
				fill="none"
			></path>
			<path
				className="circle"
				strokeDasharray={`${value}, 100`}
				d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
				stroke={value < 80 && value > 0 ? "#FFBC1F" : value > 79 ? "#40D30D" : "transparent"}
				strokeWidth="2.4"
				fill="none"
			></path>
		</svg>
	);
};

// CourseOverviewView Component
export const CourseOverviewView = (props) => {
	const courseDataItems = props.courseData;
	if (!courseDataItems.length) {
		return null;
	}
	const courseDataItem = props.courseData[0];
	const courseCurrentItem = courseDataItem.current;
	const uid = courseDataItem.uid;
	const sid = props.sid ? props.sid : courseCurrentItem.id;
	const [isLockedVidPopup, setIsLockedVidPopup] = useState(false);
	const [isStateChange, setIsStateChange] = useState(false);
	const [isCongratulationsPopup, setIsCongratulationsPopup] = useState(false);
	const [activeTabIndex, setActiveTabIndex] = useState(props.onTab);
	const [vidHeight, setVidHeight] = useState(350);
	const [count, setCount] = useState(0);
	
	const vidDiv = useRef();
	useEffect(() => {
		let timer;
		const player = new Plyr("#player", {
			controls: ["play-large", "play", "progress", "current-time", "duration", "mute", "volume", "settings", "fullscreen"],
		});
		if (count) {
			player.source = {
				type: "video",
				sources: [
					{
						src: `${apiEndpoints.baseUrl}/assets/videos/${courseCurrentItem.video_url}`,
						type: "video/mp4",
					},
				],
				autoplay: true,
			};
		} else {
			player.source = {
				type: "video",
				sources: [
					{
						src: `${apiEndpoints.baseUrl}/assets/videos/${courseCurrentItem.video_url}`,
						type: "video/mp4",
					},
				],
			};
		}
		player.once("canplay", (event) => {
			const currentTime = courseCurrentItem.time_watched ? courseCurrentItem.time_watched : 0;
			// console.log(currentTime);
			player.currentTime = currentTime;
		});
		if (courseCurrentItem.has_seen == null || courseCurrentItem.has_seen == 0) {
			serviceProvider.post("/item?type=sethasseen", JSON.stringify({ uid: uid, sid: sid }),true);
		}
		player.on("playing", (event) => {
			var secid = document.getElementById("sectionid").value;
			var time = player.currentTime;
			serviceProvider.post("/item?type=settime", JSON.stringify({ uid: uid, sid: secid, time: time }),true);
			
		});
		player.on("ended", (event) => {
			var secid = document.getElementById("sectionid").value;
			serviceProvider.post("/item?type=sethascomplete", JSON.stringify({ uid: uid, sid: secid }),true).then((response) => {
				if (response.data.islast == 1) {
					setIsCongratulationsPopup(!isCongratulationsPopup);
				} else {
					const vurl = `${apiEndpoints.baseUrl}/assets/videos/${response.data.video_url}`;
					player.source = {
						type: "video",
						sources: [{ src: vurl, type: "video/mp4" }],
						autoplay: true,
					};
					props.onComplete(response.data.nsid);
				}
			});
		});

		
		const vidTimeout = setTimeout(() => {
			if (screen.width > 768) {
				const tmpVidDiv = vidDiv;
				setVidHeight(tmpVidDiv.current.offsetHeight);
			}
		}, 1000);
		return () => {
			setCount(1);
			clearTimeout(vidTimeout);
			player.destroy();
			
		};
	}, [sid, props.tid, courseCurrentItem.id]);
	const TrainTabPane = (props) => {
		return <>{props.item == activeTabIndex ? <>{props.children}</> : ""}</>;
	};

	const HandleTabChange = (index) => {
		setActiveTabIndex(index);
	};
	const HandlePlayPrevious = (index) => {
		setIsStateChange(true);
		props.onComplete(index);
	};
	const HandlePlayPreviousPopup = (index) => {
		props.onComplete(0);
		props.onAllComplete(1);
		setIsCongratulationsPopup(!isCongratulationsPopup);
	};
	const HandleLockVidPopup = () => {
		setIsLockedVidPopup(!isLockedVidPopup);
	};
	const HandleCongratulationsPopup = () => {
		props.onAllComplete(1);
		setIsCongratulationsPopup(!isCongratulationsPopup);
	};
	const HandleValueOnChange = (e) => {
		return true;
	};
	const submitQuestion = () => {
		var ques = document.getElementById("txtSendMsg").value;
		if (ques) {
			serviceProvider
				.post("/item?type=savequestion", JSON.stringify({ uid: uid, cid: courseDataItem.id, ques: ques }),true)
				.then((response) => {
					document.getElementById("txtSendMsg").value = "";
					props.onSubmitQues(response.data);
				});
		}
	};
	const submitAnswers = (event) => {
		const qid = event.target.id;
		if(document.getElementById("txtReplyMsg-" + qid) != null ){
		var ans = document.getElementById("txtReplyMsg-" + qid).value;
			if (ans) {
				serviceProvider.post("/item?type=saveanswer", JSON.stringify({ uid: uid, qid: qid, ans: ans }),true).then((response) => {
					props.onSubmitAns(response.data);
				});
			}
		}
	};
	const secondsToHms = (d) => {
		d = Number(d);
		var h = Math.floor(d / 3600);
		var m = Math.floor((d % 3600) / 60);
		var s = Math.floor((d % 3600) % 60);
		if (d == 0) {
			return "0m";
		}
		var hDisplay = h > 0 ? h + (h == 1 ? "h " : "h ") : "";
		var mDisplay = m > 0 ? m + (m == 1 ? "m " : "m ") : "";
		var sDisplay = s > 0 ? s + (s == 1 ? "s" : "s") : "";
		return hDisplay + mDisplay + sDisplay;
	};
	const secondsToHmOnly = (d) => {
		d = Number(d);
		var h = Math.floor(d / 3600);
		var m = Math.floor((d % 3600) / 60);
		var s = Math.floor((d % 3600) % 60);
		if (d == 0) {
			return "0m";
		}
		var hDisplay = h == 0 ? "0h " : h + "h ";
		var mDisplay = m > 0 ? m + (m == 1 ? "m " : "m ") : "";
		// var sDisplay = s > 0 ? s + (s == 1 ? "s" : "s") : "";
		var sDisplay = "";
		return hDisplay + mDisplay + sDisplay;
	};
	let totalTime = 0;
	let doneTime = 0;
	const courseDataItemSections = courseDataItem.sections.map((section, index) => {
		totalTime = totalTime + parseInt(section.section_duration);
		if (section.has_complete == 1) {
			doneTime = doneTime + parseInt(section.section_duration);
		}

		if (section.id == sid) {
			var status =
				section.id == courseCurrentItem.id && courseDataItem.currentsid != 0 ? "play" : courseDataItem.allcomplete == 1 ? "complete" : "play";
			return (
				<ContentList key={section.id} course_slug={section.course_slug} section_slug={section.section_slug} status={status} listTitle={section.section_name} listTime={secondsToHms(section.section_duration)} />
			);
		} else if (section.has_complete == 1 || section.has_seen == 1) {
			return (
				<ContentList
					key={section.id}
					course_slug={section.course_slug} 
					section_slug={section.section_slug}
					status="complete"
					listTitle={section.section_name}
					listTime={secondsToHms(section.section_duration)}
					callBackFunction={() => HandlePlayPrevious(section.id)}
				/>
			);
		} else {
			return (
				<ContentList
					key={section.id}
					course_slug={section.course_slug} 
					section_slug={section.section_slug}
					status="none"
					listTitle={section.section_name}
					listTime={secondsToHms(section.section_duration)}
					callBackFunction={HandleLockVidPopup}
				/>
			);
		}
	});
	const courseDataItemDetails = courseDataItem.details.map((detail) => {
		return (
			<div key={detail.id} className="wyl__col">
				<p className="wyl__chk__text">
					<span className="wyl__chk__icon">
						<img src={require("../../assets/img/course-detail/checkmark.svg").default} alt="true" />
					</span>
					<span>{detail.detail}</span>
				</p>
			</div>
		);
	});
	const Qnasection = courseDataItem.questions.map((ques) => {
		return (
			<ul key={ques.id} id={`qna-${ques.id}`} className="qna__tabpane__card__ul">
				<li className="qna__tabpane__card__li">
					<Box className="commented__box" component="div">
						<Box className="commented__head" component="header">
							<Box component="section" className="cmnt__head__lft">
								<Avatar className={`name__cir cir-${ques.initial}`}>{ques.shortname}</Avatar>
								<Box component="p" className="cmnt__head__name">
									<span>
										{ques.name} {ques.last_name}
									</span>
								</Box>
							</Box>

							<Box component="section" className="cmnt__head__rgt">
								<span>{ques.datecreated}</span>
							</Box>
						</Box>

						<Box className="commented__body" component="div">
							<p className="txt">{ques.question}</p>

							<button className="commented__forward__btn">
								<img src={require("../../assets/img/common-img/forward.svg").default} />
							</button>
						</Box>
					</Box>
				</li>
				{ques.answers.length ? (
					ques.answers.map((ans) => (
						<li key={ans.id} className="qna__tabpane__card__li">
							<div className="sub__li">
								<Box className="commented__box" component="div">
									<Box className="commented__head" component="header">
										<Box component="section" className="cmnt__head__lft">
											<Avatar className={`name__cir cir-${ans.initial}`}>
												{/* <img src={require("../../assets/img/course-overview/instructor.svg").default} atr="true" /> */}
												{ans.shortname}
											</Avatar>
											<Box component="p" className="cmnt__head__name">
												<span>
													{ans.name} {ans.last_name}
												</span>
												{ans.is_star == 1 && (
													<span className="star__img">
														<img src={require("../../assets/img/course-overview/star-blue-cir.svg").default} alt="true" />
													</span>
												)}
											</Box>
										</Box>

										<Box component="section" className="cmnt__head__rgt">
											<span>{ans.datecreated}</span>
										</Box>
									</Box>

									<Box className="commented__body" component="div">
										<p className="txt">{ans.answer}</p>
										<button className="commented__forward__btn">
											<img src={require("../../assets/img/common-img/forward.svg").default} />
										</button>
									</Box>
								</Box>
							</div>
						</li>
					))
				) : (
					<></>
				)}
				<li className="qna__tabpane__card__li">
					<div className="sub__li">
						<div className="course__tabpane__card send__comment__card">
							<div className="send__comment__card__content">
								<div className="name__cir__wrapper">
									<Avatar className={`name__cir cir-${courseDataItem.initial}`}>{courseDataItem.shortname}</Avatar>
								</div>
								<textarea
									id={`txtReplyMsg-${ques.id}`}
									placeholder="Reply to this thread"
									className="text__send__msg text__reply__msgs"
								/>

								<div className="send__btn__div">
									<button className="send__btn" id={ques.id} onClick={submitAnswers}>
										<span>Reply</span>
									</button>
								</div>
							</div>
						</div>
					</div>
				</li>
			</ul>
		);
	});
	let leftTime = totalTime - doneTime;
	let completePerc = 0;
	if (doneTime) {
		completePerc = Math.round((doneTime / totalTime) * 100);
	}
	return (
		<React.Fragment>
			<Helmet>
				<title>{courseDataItem.course_name} | SmarterChains</title>
				<meta name="description" content={courseDataItem.meta_desc} />
				<meta name="og:image" content={`${apiEndpoints.baseUrl}/assets/img/meta/${courseDataItem.meta_img}`} />
			</Helmet>
			<BreadcrumbsItem to="/">Home</BreadcrumbsItem>
			<BreadcrumbsItem to="/training-courses">IR4.0 Training Courses</BreadcrumbsItem>
			<BreadcrumbsItem to="#">{courseDataItem.course_name}</BreadcrumbsItem>
			<div className="master_wrapper course__overview">
				<div className="course__overview__head">
					<div className="head__left__frame">
						<h1 className="course__overView__h1">
							<span
								className="course__back__btn"
								onClick={() => {
									HandlePageOnClick("/training-courses", { ...props });
								}}
							>
								<img
									className="course__back__btn_img"
									src={require("../../assets/img/course-detail/back-course.svg").default}
									alt="true"
								/>
							</span>
							<span className={`${props.sid}-${courseCurrentItem.id}-${sid}`}>{courseDataItem.course_name}</span>
						</h1>
						<h2 className="course__overView__h1_small">
							{courseDataItem.id == 11 ? "INDUSTRY 4.0 INTRODUCTORY COURSE" : "INDUSTRY 4.0 DIMENSION TRAININGS"}
						</h2>
					</div>

					<div className="head__right__frame">
						<TrainProgressBar value={completePerc} doneTime={secondsToHmOnly(doneTime)} leftTime={secondsToHmOnly(leftTime)} />
					</div>
				</div>

				<div className="course__inner__wrapper">
					<div className="course__inner__top__sec">
						<div className="course__inner__top__left" style={{ height: `${screen.width > 768 && vidHeight}px` }}>
							<div className="course__inner__ul__wrapper">
								<div className="course__inner__ul__head">
									<div className="course__inner__ul__head__h1">
										<div className="head__h1__icon">
											<img src={require("../../assets/img/course-overview/content_head.svg").default} alt="true" />
										</div>
										<div className="head__h1__text">
											<span>Contents</span>
										</div>
									</div>
								</div>

								<ul className="course__inner__ul">{courseDataItemSections}</ul>
							</div>
						</div>

						<div className="course__inner__top__right" ref={vidDiv}>
							{/* <VideoPlayer videoSrc={videoSrc} /> */}
							<input id="sectionid" value={sid} readOnly style={{ display: "none" }} />
							<video id="player" controls crossorigin playsInline></video>
						</div>
					</div>

					<div className="course__inner__tab__sec">
						<div className="course__inner__tabs">
							<button
								className={activeTabIndex === 0 ? "course__inner__tab__btn active" : "course__inner__tab__btn"}
								onClick={() => HandleTabChange(0)}
								type="button"
							>
								<span className="course__inner__tab__img">
									<img src={require("../../assets/img/course-overview/tab_overview_active.svg").default} className="active" />
									<img src={require("../../assets/img/course-overview/tab_overview_inactive.svg").default} className="inactive" />
								</span>
								<span>Overview</span>
							</button>

							<button
								className={activeTabIndex === 1 ? "course__inner__tab__btn active" : "course__inner__tab__btn"}
								onClick={() => HandleTabChange(1)}
								type="button"
							>
								<span className="course__inner__tab__img">
									<img src={require("../../assets/img/course-overview/tab_qna_active.svg").default} className="active" />
									<img src={require("../../assets/img/course-overview/tab_qna_inactive.svg").default} className="inactive" />
								</span>
								<span>Questions & Answers</span>
							</button>

							<button
								className={activeTabIndex === 2 ? "course__inner__tab__btn active" : "course__inner__tab__btn"}
								onClick={() => HandleTabChange(2)}
								type="button"
							>
								<span className="course__inner__tab__img">
									<img src={require("../../assets/img/course-overview/tab_quiz_active.svg").default} className="active" />
									<img src={require("../../assets/img/course-overview/tab_quiz_inactive.svg").default} className="inactive" />
								</span>
								<span>Quiz</span>
							</button>
						</div>

						<div className="course__inner__tab__panels">
							<TrainTabPane item={0} activeTabIndex={activeTabIndex} {...props}>
								<div className="course__overview__tabpane">
									<div className="course__overview__frame__wrapper overview_tabpane_frame">
										<div className="course__overview__frame__left">
											<div className="course__tabpane__card abt__course">
												<h3 className="h1">About this course</h3>
												<div className="abt__course__row">
													<div className="abt__course__col__lft">
														<div
															dangerouslySetInnerHTML={{
																__html: courseDataItem.course_description,
															}}
														></div>
													</div>
													<div className="abt__course__col__rgt">
														<img
															src={
																require(`../../assets/img/training-card/inner-${courseDataItem.course_icon}`).default
															}
															alt={courseDataItem.course_name}
														/>
													</div>
												</div>
											</div>
										</div>

										<div className="course__overview__frame__right">
											<div className="share__course__card">
												<div className="share__course__row">
													<span className="share__course__txt">Share this course:</span>
													<div className="share__course__link">
														<LinkedinShareButton quote="" url={window.location.href}>
															<img
																className="linkedin"
																src={require("../../assets/img/social-media/linked-in.svg").default}
																alt="share_linked_in"
															/>
														</LinkedinShareButton>
													</div>
													<div className="share__course__link">
														<FacebookShareButton quote="" url={window.location.href}>
															<img
																className="facebook"
																src={require("../../assets/img/social-media/facebook.svg").default}
																alt="share_facebook"
															/>
														</FacebookShareButton>
													</div>
													<div className="share__course__link">
														<TwitterShareButton quote="" url={window.location.href}>
															<img
																className="twitter"
																src={require("../../assets/img/social-media/twitter.svg").default}
																alt="share_twitter"
															/>
														</TwitterShareButton>
													</div>
												</div>
											</div>
										</div>
									
										<div className="course__overview__frame__right" style={{ display: "none" }}>
											<div className="course__tabpane__card instructor">
												<h3 className="title">Instructor</h3>
												<Avatar
													alt={courseDataItem.i_name}
													className="instructor__img"
													src={require(`../../assets/img/course-instructor/${courseDataItem.i_avatar}`).default}
												/>
												<div className="inst__social__icons">
													<a href={courseDataItem.i_linkedin} target="_blank">
														<img src={require("../../assets/img/social-media/linked-in.svg").default} alt="linked_in" />
													</a>
												</div>
												<div className="about__instructor">
													<p className="inst__name">{courseDataItem.i_name}</p>
													<p className="inst__about__text">{courseDataItem.i_position}</p>
													<p className="inst__about__text i_from">{courseDataItem.i_from}</p>
												</div>
											</div>
										</div>

										<div className="course__overview__frame__left">
											<div className="course__tabpane__card wyl">
												<h3 className="h1">What you’ll learn</h3>
												<div className="wyl__row">{courseDataItemDetails}</div>
											</div>
										</div>

										
									</div>
								</div>
							</TrainTabPane>
							<TrainTabPane item={1} activeTabIndex={activeTabIndex} {...props}>
								<div className="course__overview__tabpane">
									<div className="course__overview__frame__wrapper qna__tabpane__frame">
										<QNAUpdate {...props} />
									</div>
								</div>
							</TrainTabPane>
							<TrainTabPane item={2} activeTabIndex={activeTabIndex} {...props}>
								<div className="course__overview__tabpane">
									{courseDataItem.score < 80 ? (
										<div className="course__overview__frame__wrapper quiz__tabpane__frame">
											<div className="course__overview__frame__left">
												<div className="course__tabpane__card quiz__card">
													<h3 className="h1">Quiz: {courseDataItem.course_name}</h3>
													<div className="quiz__card__body">
														<p>
															Test your knowledge with the course Quiz and get your Certificate. Unlock the Quiz by
															watching all the course sections. Score 80% or higher to get your certificate. You can
															retake the Quiz after 8 hours in case you failed.
														</p>
													</div>
													<Link
														to={`/training-quiz/${courseDataItem.course_slug}`}
														className={completePerc == 100 ? "quiz__card__btn" : "quiz__card__btn disabled"}
													>
														<span className="img__span">
															<img
																src={require("../../assets/img/course-overview/cir-quiz-btn.svg").default}
																alt="true"
															/>
														</span>
														{courseDataItem.score > 0 ? <span>Retake Quiz</span> : <span>Take Quiz</span>}
													</Link>
												</div>
											</div>

											<div className="course__overview__frame__right">
												<div className="course__tabpane__card your__score__card">
													<h3 className="h1">Your Score is</h3>
													<div className="your__score__cir">
														<SvgCircle value={courseDataItem.score} />
													</div>
													{/* when value is less than  100 and greater than 0*/}
													<p>on the quiz</p>
													{/* when value is 0*/}
													{courseDataItem.score > 0 && <p>You didn’t pass this time</p>}
												</div>
											</div>
										</div>
									) : (
										<div className="course__overview__frame__wrapper quiz__tabpane__frame">
											<div className="course__overview__frame__left">
												<div className="course__tabpane__card congrats__main__card">
													<div className="cong__card">
														<div className="cong__card__img">
															<img
																className=""
																src={require("../../assets/img/course-overview/congrats-completed.svg").default}
																alt="true"
															/>
														</div>

														<div className="cong__card__content">
															<p className="cong_blue_text">Congratulations!</p>
															<p>You've successfully completed the Quiz:</p>
															<p className="b">{courseDataItem.course_name}</p>
															<a target="_blank" href={courseDataItem.certificateUrl} className="cong__btue__btn">
																Download your certificate
															</a>
														</div>
													</div>
												</div>
											</div>

											<div className="course__overview__frame__right">
												<div className="course__tabpane__card your__score__card course__hover__card">
													<h3 className="h1">Your Score is</h3>
													<div className="your__score__cir">
														<SvgCircle value={courseDataItem.score} />
													</div>
													<p>You have passed the Quiz!</p>
													<Link to={`/training-quiz/${courseDataItem.course_slug}`} className="quiz__card__hv_btn">
														See the Quiz Results
													</Link>
												</div>
											</div>
										</div>
									)}
								</div>
							</TrainTabPane>
						</div>
					</div>
				</div>
			</div>

			{/* {props.isLockedVidPopup ? <LockedVideoPoup HandleLockVidPopup={props.HandleLockVidPopup} /> : ""} */}
			<div className={`locked__video__parent ${isLockedVidPopup ? "visible active" : ""}`}>
				<div className="locked__video__popup">
					<div className="popup__content">
						<button className="close__popup" onClick={HandleLockVidPopup}>
							<img src={require("../../assets/img/common-img/close-icon-blue.svg").default} />
						</button>
						<img src={require("../../assets/img/course-overview/vid_lock.svg").default} className="popup__top__img" alt="true" />
						<p>Please complete the previous course section to be able to access this video</p>
						<button className="popup__btn" onClick={HandleLockVidPopup}>
							OK
						</button>
					</div>
				</div>
			</div>
			<div className={`congratulation__popup__parent ${isCongratulationsPopup ? "visible active" : ""}`}>
				<div className="congratulation__popup">
					<div className="congratulation__content">
						<button className="close__popup" onClick={HandlePlayPreviousPopup}>
							<img src={require("../../assets/img/common-img/close-icon-blue.svg").default} />
						</button>
						<img className="congrats_img" src={require("../../assets/img/course-overview/congrats__top__img.gif").default} alt="true" />
						<div>
							<p className="congratulation__blue">Congratulations!</p>
							<p>You've successfully completed the Course:</p>
							<p className="b">{courseDataItem.course_name}</p>
							<div className="cong__btn__wrapper">
								<div className="cong__btn__col">
									<button className="cong__btn__blue__border" onClick={HandlePlayPreviousPopup}>
										I’ll do the Quiz later
									</button>
								</div>
								<div className="cong__btn__col">
									<Link to={`/training-quiz/${courseDataItem.course_slug}`} className="cong__btn__blue">
										Take the Quiz
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};




// QNAUpdate Component
const QNAUpdate = (props) => {
	
	const [searchVal, setSearchVal] = React.useState('');
	const [filterOpen, setFilterOpen] = React.useState(null);
	const [isReportPopup, setIsReportPopup] = React.useState(false);
	const [isCardReply, setIsCardReply] = React.useState(0);
	const questDataItem = props.courseData[0];
	const searchInput = React.useRef();
	const HandleInputValue = (e) => {  
	  let val = e.target.value;
	  setSearchVal(val);
	}
	const HandleSearch = () => {
	  if (searchVal.length == 0) {
		searchInput.current.focus();
	  } else {
		setSearchVal('');
		searchInput.current.focus();
	  }
	}
	const HandleReportPopup = () => {
	  setIsReportPopup(!isReportPopup);
	}
	const HandleCard = (value) => {
	  setIsCardReply(value)
	}
	
	
	return (
	  <>
		<div className="edu-qa-wrapper">
		  <div className="course__inner__tab__sec">
			<div className="course__inner__tab__panels">
			  <div className="course__overview__tabpane">
				<div className="course__overview__frame__wrapper qna__tabpane__frame">
				  {/* search and filter sec  */}
				  <div className="course__overview__frame__left">
					<div className={`qna-search-box ${searchVal.length > 0 && 'active'}`}>
					  <input
						type="text"
						value={searchVal}
						onChange={(e) => HandleInputValue(e)}
						ref={searchInput}
						placeholder="Search questions that can help you"
					  />
					  <button onClick={HandleSearch}>
						<img src={require('../../assets/img/common-img/qna-search.svg').default} className="inactive" alt="true" />
						<img src={require('../../assets/img/common-img/qna-cancel-src.svg').default} className="active" alt="true" />
					  </button>
					</div>
					<div className="qna-filter-wrapper">
					  <div className="qna-filter-col">
						<QnaFilter
						  itemNumber={1}
						  ActiveItem={filterOpen}
						  setActiveItem={setFilterOpen}
						  options={
							[
							  {
								title: 'Sort by most recent',
								value: '1'
							  },
							  {
								title: 'Sort by most upvoted',
								value: '2'
							  },
							  {
								title: 'Sort by reccommended',
								value: '3'
							  },
							]
						  } title="Sort by reccommended" {...props} />
					  </div>
					  <div className="qna-filter-col">
						<QnaFilter
						  itemNumber={2}
						  ActiveItem={filterOpen}
						  setActiveItem={setFilterOpen}
						  title="Filter Questions"
						  options={
							[
							  {
								title: 'All Questions',
								value: '1'
							  },
							  {
								title: 'Questions I asked',
								value: '2'
							  },
							  {
								title: 'Questions I am following',
								value: '3'
							  },
							]
						  }  {...props} />
					  </div>
					  <div className="qna-filter-col">
						<button className={`qna-btn-submit ${isCardReply === 2 ? 'active' : ''}`} onClick={() => HandleCard(2)}>
						  Submit a new question
						</button>
					  </div>
					</div>
				  </div>
				  {/* search and filter sec  */}
				  <div
					className="course__overview__frame__left"
					style={{ display: isCardReply === 0 ? '' : 'none' }}
				  >
					<h2 className="h2">
					  All questions in this course<span>({questDataItem.total_ques})</span>
					</h2>
					<div className="course__tabpane__card">
					  <ul id="qna-80" className="qna__tabpane__card__ul">
					   {questDataItem.questions.map((ques) => {
						   return (
						<li className="qna__tabpane__card__li" onClick={() => HandleCard(1)}>
						  <div className="MuiBox-root MuiBox-root-2 commented__box">
							<header className="MuiBox-root MuiBox-root-4 commented__head">
							  <section className="MuiBox-root MuiBox-root-6 cmnt__head__lft">
								<div className={`MuiAvatar-root MuiAvatar-circle name__cir cir-${ques.initial} MuiAvatar-colorDefault`}>
								  {ques.shortname}
								</div>
								<p className="MuiBox-root MuiBox-root-8 cmnt__head__name">
								  <span>{ques.name} {ques.last_name}</span>
								</p>
							  </section>
							</header>
							<div className="MuiBox-root MuiBox-root-12 commented__body">
							  <p className="txt">
								{ques.question}
							  </p>
							</div>
							<section className="MuiBox-root MuiBox-root-10 cmnt__head__rgt">
							  <span className="cmnt__head__rgt-date gray">
								{ques.datecreated}
							  </span>
							  <span className="from-text">
								From: <label>Innovation</label>
							  </span>
							</section>
						  </div>
						  <div className="qa_share_like_wrap">
							<button className="commented__forward__btn">
							  <span className="commented__forward__btn-count">
								0
							  </span>
							  <img
								src={
								  require("../../assets/img/common-img/qa-like-icon.svg")
									.default
								}
							  />
							</button>
							<button className="commented__forward__btn">
							  <span className="commented__forward__btn-count">
								{ques.answers.length}
							  </span>
							  <img
								src={
								  require("../../assets/img/common-img/qa-reply-icon.svg")
									.default
								}
							  />
							</button>
						  </div>
						</li>
						
					   ); })}
					  </ul>
					</div>
				  </div>
				  {/* view question wrap end */}
				  <div className="course__overview__frame__left back-to-q" style={{ display: isCardReply === 1 ? '' : 'none' }}>
					<button className="h2" onClick={() => HandleCard(0)}>
					  <img
						className="qa-back_arrow"
						src={
						  require("../../assets/img/common-img/qa-arrow_back.svg")
							.default
						}
					  />
					  Back to all questions
					</button>
					<div className="course__tabpane__card">
					  <ul id="qna-80" className="qna__tabpane__card__ul">
						<li className="qna__tabpane__card__li">
						  <div className="MuiBox-root MuiBox-root-2 commented__box">
							<header className="MuiBox-root MuiBox-root-4 commented__head">
							  <section className="MuiBox-root MuiBox-root-6 cmnt__head__lft">
								<div className="MuiAvatar-root MuiAvatar-circle name__cir cir-p MuiAvatar-colorDefault">
								  AK
								</div>
								<p className="MuiBox-root MuiBox-root-8 cmnt__head__name">
								  <span>Adam Kirsten</span>
								</p>
							  </section>
							</header>
							<div className="MuiBox-root MuiBox-root-12 commented__body">
							  <p className="txt">
								Which technology of the above can be used in
								non-touch production?
							  </p>
							</div>
							<section className="MuiBox-root MuiBox-root-10 cmnt__head__rgt">
							  <span className="cmnt__head__rgt-date gray">
								October 14, 2021 5:58 PM
							  </span>
							  <span className="from-text">
								From: <label>Innovation</label>
							  </span>
							</section>
						  </div>
						  <div className="qa_share_like_wrap">
							<button className="commented__forward__btn">
							  <span className="commented__forward__btn-count">
								21
							  </span>
  
							  <svg
								width="30"
								height="30"
								className="qa-like-icon"
								viewBox="0 0 30 30"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							  >
								<path
								  d="M25 16.8751C25 16.3742 24.8008 15.9076 24.4575 15.5634C24.8467 15.1376 25.045 14.5667 24.9908 13.9726C24.8933 12.9134 23.9391 12.0834 22.8175 12.0834H17.67C17.925 11.3092 18.3333 9.89007 18.3333 8.75007C18.3333 6.94257 16.7975 5.41675 15.8333 5.41675C14.9683 5.41675 14.3491 5.90425 14.3233 5.92425C14.2241 6.00343 14.1666 6.12343 14.1666 6.25007V9.07589L11.7658 14.2751L11.6666 14.3259V14.1667C11.6666 13.9367 11.48 13.75 11.25 13.75H7.08332C5.93418 13.7501 5 14.6842 5 15.8334V22.5001C5 23.6492 5.93418 24.5834 7.08332 24.5834H9.58332C10.4841 24.5834 11.2541 24.0084 11.5441 23.2059C12.2375 23.5626 13.1708 23.7501 13.75 23.7501H21.3992C22.3067 23.7501 23.1009 23.1384 23.2875 22.2951C23.3833 21.8601 23.3275 21.4226 23.1375 21.0426C23.7525 20.7334 24.1667 20.0976 24.1667 19.3751C24.1667 19.0801 24.0992 18.7976 23.9717 18.5426C24.5867 18.2326 25 17.5976 25 16.8751ZM23.2425 17.9034C23.0817 17.9226 22.9458 18.0317 22.8942 18.1859C22.8434 18.3401 22.8859 18.5092 23.0042 18.6209C23.2159 18.8201 23.3334 19.0884 23.3334 19.3751C23.3334 19.9009 22.9359 20.3426 22.41 20.4034C22.2492 20.4226 22.1134 20.5317 22.0617 20.6859C22.0109 20.8401 22.0534 21.0092 22.1717 21.1209C22.4459 21.3792 22.5559 21.7417 22.4734 22.1151C22.3709 22.5801 21.9192 22.9167 21.3992 22.9167H13.75C13.0733 22.9167 11.9383 22.5992 11.545 22.2051C11.4258 22.0867 11.2458 22.0517 11.0908 22.1151C10.935 22.1792 10.8333 22.3317 10.8333 22.5001C10.8333 23.1892 10.2725 23.7501 9.58332 23.7501H7.08332C6.39414 23.7501 5.83332 23.1892 5.83332 22.5001V15.8334C5.83332 15.1442 6.39414 14.5834 7.08332 14.5834H10.8333V15.0001C10.8333 15.1442 10.9083 15.2784 11.0316 15.3551C11.1533 15.4284 11.3066 15.4359 11.4366 15.3726L12.27 14.9559C12.3541 14.9142 12.4216 14.8442 12.4616 14.7584L14.9616 9.34171C14.9866 9.28671 15 9.22671 15 9.16671V6.47589C15.1733 6.38007 15.4742 6.25007 15.8333 6.25007C16.29 6.25007 17.5 7.38507 17.5 8.75007C17.5 10.2167 16.7017 12.3309 16.6942 12.3517C16.6459 12.4792 16.6625 12.6234 16.74 12.7367C16.8183 12.8492 16.9467 12.9167 17.0833 12.9167H22.8175C23.5125 12.9167 24.1025 13.4142 24.1608 14.0492C24.205 14.5242 23.9766 14.9759 23.5675 15.2284C23.44 15.3067 23.3642 15.4484 23.37 15.5992C23.3758 15.7501 23.4625 15.8851 23.5958 15.9542C23.9483 16.1334 24.1666 16.4867 24.1666 16.8751C24.1667 17.4009 23.7692 17.8426 23.2425 17.9034Z"
								  fill="url(#paint0_linear)"
								/>
								<path
								  d="M11.2499 14.5833C11.0199 14.5833 10.8333 14.7699 10.8333 14.9999V22.4999C10.8333 22.7299 11.0199 22.9166 11.2499 22.9166C11.4799 22.9166 11.6666 22.7299 11.6666 22.4999V14.9999C11.6666 14.7699 11.4799 14.5833 11.2499 14.5833Z"
								  fill="url(#paint1_linear)"
								/>
								<defs>
								  <linearGradient
									id="paint0_linear"
									x1="7.66667"
									y1="1.10423"
									x2="25.8487"
									y2="1.71109"
									gradientUnits="userSpaceOnUse"
								  >
									<stop stop-color="#139BD6" />
									<stop offset="1" stop-color="#0789CF" />
								  </linearGradient>
								  <linearGradient
									id="paint1_linear"
									x1="10.9444"
									y1="12.7082"
									x2="11.7028"
									y2="12.7107"
									gradientUnits="userSpaceOnUse"
								  >
									<stop stop-color="#139BD6" />
									<stop offset="1" stop-color="#0789CF" />
								  </linearGradient>
								</defs>
							  </svg>
  
							  {/* <img
								src={
								  require("../../assets/img/common-img/qa-like-icon.svg")
									.default
								}
							  /> */}
							</button>
							
						  </div>
						  <div className="qa-rep-foll-wrap">
							<span className="qa-reply">4 Replies</span>
						
						  </div>
						</li>
						<li className="qna__tabpane__card__li qa-instructor">
						  <div className="qa-instructor-in">
							<div className="MuiBox-root MuiBox-root-2 commented__box">
							  <header className="MuiBox-root MuiBox-root-4 commented__head">
								<section className="MuiBox-root MuiBox-root-6 cmnt__head__lft">
								  <div className="MuiAvatar-root MuiAvatar-circle name__cir cir-p MuiAvatar-colorDefault">
									AT
								  </div>
								  <p className="MuiBox-root MuiBox-root-8 cmnt__head__name">
									<span>Angelos Tsoutsias</span>
									<img
									  className="instructor-badge"
									  src={
										require("../../assets/img/common-img/instructor-badge.svg")
										  .default
									  }
									/>
								  </p>
								</section>
							  </header>
							  <div className="MuiBox-root MuiBox-root-12 commented__body">
								<p className="txt">
								  Hey Adam! All of them can be used in non-touch
								  prduction.
								</p>
							  </div>
							  <section className="MuiBox-root MuiBox-root-10 cmnt__head__rgt">
								<span className="cmnt__head__rgt-date gray">
								  October 14, 2021 5:58 PM
								</span>
								<span className="from-text">
								  From: <label>Innovation</label>
								</span>
							  </section>
							</div>
							<div className="qa_share_like_wrap">
							  <button className="commented__forward__btn">
								<span className="commented__forward__btn-count">
								  21
								</span>
								<svg
								  width="30"
								  height="30"
								  className="qa-like-icon"
								  viewBox="0 0 30 30"
								  fill="none"
								  xmlns="http://www.w3.org/2000/svg"
								>
								  <path
									d="M25 16.8751C25 16.3742 24.8008 15.9076 24.4575 15.5634C24.8467 15.1376 25.045 14.5667 24.9908 13.9726C24.8933 12.9134 23.9391 12.0834 22.8175 12.0834H17.67C17.925 11.3092 18.3333 9.89007 18.3333 8.75007C18.3333 6.94257 16.7975 5.41675 15.8333 5.41675C14.9683 5.41675 14.3491 5.90425 14.3233 5.92425C14.2241 6.00343 14.1666 6.12343 14.1666 6.25007V9.07589L11.7658 14.2751L11.6666 14.3259V14.1667C11.6666 13.9367 11.48 13.75 11.25 13.75H7.08332C5.93418 13.7501 5 14.6842 5 15.8334V22.5001C5 23.6492 5.93418 24.5834 7.08332 24.5834H9.58332C10.4841 24.5834 11.2541 24.0084 11.5441 23.2059C12.2375 23.5626 13.1708 23.7501 13.75 23.7501H21.3992C22.3067 23.7501 23.1009 23.1384 23.2875 22.2951C23.3833 21.8601 23.3275 21.4226 23.1375 21.0426C23.7525 20.7334 24.1667 20.0976 24.1667 19.3751C24.1667 19.0801 24.0992 18.7976 23.9717 18.5426C24.5867 18.2326 25 17.5976 25 16.8751ZM23.2425 17.9034C23.0817 17.9226 22.9458 18.0317 22.8942 18.1859C22.8434 18.3401 22.8859 18.5092 23.0042 18.6209C23.2159 18.8201 23.3334 19.0884 23.3334 19.3751C23.3334 19.9009 22.9359 20.3426 22.41 20.4034C22.2492 20.4226 22.1134 20.5317 22.0617 20.6859C22.0109 20.8401 22.0534 21.0092 22.1717 21.1209C22.4459 21.3792 22.5559 21.7417 22.4734 22.1151C22.3709 22.5801 21.9192 22.9167 21.3992 22.9167H13.75C13.0733 22.9167 11.9383 22.5992 11.545 22.2051C11.4258 22.0867 11.2458 22.0517 11.0908 22.1151C10.935 22.1792 10.8333 22.3317 10.8333 22.5001C10.8333 23.1892 10.2725 23.7501 9.58332 23.7501H7.08332C6.39414 23.7501 5.83332 23.1892 5.83332 22.5001V15.8334C5.83332 15.1442 6.39414 14.5834 7.08332 14.5834H10.8333V15.0001C10.8333 15.1442 10.9083 15.2784 11.0316 15.3551C11.1533 15.4284 11.3066 15.4359 11.4366 15.3726L12.27 14.9559C12.3541 14.9142 12.4216 14.8442 12.4616 14.7584L14.9616 9.34171C14.9866 9.28671 15 9.22671 15 9.16671V6.47589C15.1733 6.38007 15.4742 6.25007 15.8333 6.25007C16.29 6.25007 17.5 7.38507 17.5 8.75007C17.5 10.2167 16.7017 12.3309 16.6942 12.3517C16.6459 12.4792 16.6625 12.6234 16.74 12.7367C16.8183 12.8492 16.9467 12.9167 17.0833 12.9167H22.8175C23.5125 12.9167 24.1025 13.4142 24.1608 14.0492C24.205 14.5242 23.9766 14.9759 23.5675 15.2284C23.44 15.3067 23.3642 15.4484 23.37 15.5992C23.3758 15.7501 23.4625 15.8851 23.5958 15.9542C23.9483 16.1334 24.1666 16.4867 24.1666 16.8751C24.1667 17.4009 23.7692 17.8426 23.2425 17.9034Z"
									fill="url(#paint0_linear)"
								  />
								  <path
									d="M11.2499 14.5833C11.0199 14.5833 10.8333 14.7699 10.8333 14.9999V22.4999C10.8333 22.7299 11.0199 22.9166 11.2499 22.9166C11.4799 22.9166 11.6666 22.7299 11.6666 22.4999V14.9999C11.6666 14.7699 11.4799 14.5833 11.2499 14.5833Z"
									fill="url(#paint1_linear)"
								  />
								  <defs>
									<linearGradient
									  id="paint0_linear"
									  x1="7.66667"
									  y1="1.10423"
									  x2="25.8487"
									  y2="1.71109"
									  gradientUnits="userSpaceOnUse"
									>
									  <stop stop-color="#139BD6" />
									  <stop offset="1" stop-color="#0789CF" />
									</linearGradient>
									<linearGradient
									  id="paint1_linear"
									  x1="10.9444"
									  y1="12.7082"
									  x2="11.7028"
									  y2="12.7107"
									  gradientUnits="userSpaceOnUse"
									>
									  <stop stop-color="#139BD6" />
									  <stop offset="1" stop-color="#0789CF" />
									</linearGradient>
								  </defs>
								</svg>
							  </button>
							  
							</div>
						  </div>
						</li>
						<li className="qna__tabpane__card__li comment-reply-wrap">
						  <div className="course__tabpane__card send__comment__card">
							<div className="send__comment__card__content">
							  <div className="name__cir__wrapper">
								<div className="MuiAvatar-root MuiAvatar-circle name__cir cir-t MuiAvatar-colorDefault">
								  TP
								</div>
								<div className="txtReplyWrap280621">
								  <textarea
									id="txtReplyMsg-80"
									placeholder="Write your response"
									className="text__send__msg text__reply__msgs"
									defaultValue={""}
								  />
								  <div className="send__btn__div">
									<button className="send__btn" id={80}>
									  <span>Add Reply</span>
									</button>
								  </div>
								</div>
							  </div>
  
							</div>
						  </div>
  
						</li>
					  </ul>
					</div>
				  </div>
				  {/* course overview frame end */}
				  <div
					className="course__overview__frame__left submit-new-question"
					style={{ display: isCardReply === 2 ? '' : 'none' }}
				  >
					<button className="h2" onClick={() => HandleCard(0)}>
					  <img
						className="qa-back_arrow"
						src={
						  require("../../assets/img/common-img/qa-arrow_back.svg")
							.default
						}
					  />
					  Back to all questions
					</button>
					<div className="snq-content">
					  <div className="snq-ul-div">
						<p className="ul-title">
						  Tips on raising a question *dummy text*
						</p>
						<ul>
						  <li>
							Search to see if your question has been asked before.
						  </li>
						  <li>
							Search to see if your question has been asked before.
						  </li>
						</ul>
					  </div>
					  <div className="snq-text-area">
						<p className="snq-text-area-h1">
						  Enter Question
						</p>
						<textarea className="snq-textarea" defaultValue="" placeholder="Please enter your question here">
  
						</textarea>
						<button className="btn-publish">
						  Publish
						</button>
					  </div>
					</div>
					<div className="course__tabpane__card">
					  <ul className="qna__tabpane__card__ul">
						<li className="qna__tabpane__card__li">
						  <div className="MuiBox-root MuiBox-root-2 commented__box">
							<header className="MuiBox-root MuiBox-root-4 commented__head">
							  <section className="MuiBox-root MuiBox-root-6 cmnt__head__lft">
								<div className="MuiAvatar-root MuiAvatar-circle name__cir cir-p MuiAvatar-colorDefault">AK
								</div>
								<p className="MuiBox-root MuiBox-root-8 cmnt__head__name">
								  <span>Adam Kirsten</span>
								</p>
							  </section>
							</header>
							<div className="MuiBox-root MuiBox-root-12 commented__body">
							  <p className="txt">Which technology of the above can be used in non-touch production?
							  </p>
							</div>
							<section className="MuiBox-root MuiBox-root-10 cmnt__head__rgt">
							  <span className="cmnt__head__rgt-date gray">
								October 14, 2021 5:58 PM
							  </span>
							  <span className="from-text">
								From: <label>Innovation</label>
							  </span>
							</section>
						  </div>
						  <div className="qa_share_like_wrap">
							<button className="commented__forward__btn">
							  <span className="commented__forward__btn-count">
								21
							  </span>
							  <img
								src={
								  require("../../assets/img/common-img/qa-like-icon.svg")
									.default
								}
							  />
							</button>
							<button className="commented__forward__btn">
							  <span className="commented__forward__btn-count">
								4
							  </span>
							  <img
								src={
								  require("../../assets/img/common-img/qa-reply-icon.svg")
									.default
								}
							  />
							</button>
						  </div>
						</li>
					  </ul>
					</div>
				  </div>
				  {/* submit-new-question end */}
				</div>
			  </div>
			</div>
		  </div>
		</div>
		<ReportAbusePopup open={isReportPopup} HandleReportPopup={HandleReportPopup} {...props} />
	  </>
	);
  };
  
  // filter-component
  const QnaFilter = (props) => {
	const { itemNumber, ActiveItem, setActiveItem, options, title } = props;
	const ddlbox = React.useRef(null);
	const [btnTitle, setBtnTitle] = React.useState(title);
	const HandleValue = (val) => {
	  setBtnTitle(val.title);
	  setActiveItem(null);
	}
	const HandleOpenState = (e) => {
	  if (e === ActiveItem) {
		setActiveItem(null)
	  } else {
		setActiveItem(e)
	  }
	}
  
	window.onclick = (e) => {
	  if (!e.target.closest('.qna-filter-ddl-box')) {
		setActiveItem(null);
	  }
	}
	return (
	  <>
		<div className={`qna-filter-ddl-box ${itemNumber === ActiveItem ? 'active' : ''}`} ref={ddlbox}>
		  <button className="top-btn" onClick={() => HandleOpenState(itemNumber)}>
			<span>
			  {btnTitle}
			</span>
			<svg viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
			  <path d="M1.41 0.590088L6 5.17009L10.59 0.590088L12 2.00009L6 8.00009L0 2.00009L1.41 0.590088Z" />
			</svg>
		  </button>
		  <div className="filter-ddl-list">
			{options.map(
			  (item, index) => <button key={index} onClick={() => HandleValue(item)}>{item.title}</button>
			)
			}
		  </div>
		</div>
	  </>
	)
  }
  // report abuse popup
  const ReportAbusePopup = (props) => {
	const [ddlFilter, setDdlFilter] = React.useState('null')
	return (
	  <>
		{props.open && <div className="qnaReportAbuse-popup">
		  <div className="inner-wrapper">
			<div className="card">
			  <h1>
				<span>
				  Report Abuse
				</span>
				<button onClick={props.HandleReportPopup}>
				  <img src={require('../../assets/img/common-img/close-icon-blue.svg').default} className="active" alt="true" />
				</button>
			  </h1>
			  <p>
				Flagged content is reviewed by SmarterChains staff to determine whether it violates Terms of Service or Community Guidelines. *Dummy text*
			  </p>
			  <div className="qna-form-ctrl">
				<label>Issue type</label>
				<div className="qna-filter-wrapper form-content-wrapper">
				  <QnaFilter
					itemNumber={1}
					ActiveItem={ddlFilter}
					setActiveItem={setDdlFilter}
					options={
					  [
						{
						  title: 'Issue 1',
						  value: '1'
						},
						{
						  title: 'Issue 2',
						  value: '2'
						},
						{
						  title: 'Issue 3',
						  value: '3'
						},
						{
						  title: 'Issue 4',
						  value: '4'
						}
					  ]
					} title="Select an issue" {...props} />
				</div>
			  </div>
			  <div className="qna-form-ctrl">
				<label>Issue details</label>
				<textarea placeholder="Mention your issue in detail (optional)"></textarea>
			  </div>
			  <div className="qna-action-btn-wrapper">
				<button className="btn-blue-txt" onClick={props.HandleReportPopup}>
				  Cancel
				</button>
				<button className="btn-blue-bg">
				  Submit
				</button>
			  </div>
			</div>
		  </div>
		</div>}
	  </>
	)
  }